import React, { useEffect } from "react";
import Context from "../../../../../context";
import Components from "./Components";

import { CustomModal } from "../../../../../components";
import { IUpdateStudent } from "../../../../../types/student.interface";

import "./index.scss";

const UpdateStudent = () => {
  // ** ===========================================================================================================
  // **                                            Value Validation
  // ** -----------------------------------------------------------------------------------------------------------
  const { showModal, setShowModal, updateFunctionStudent, selectedService } =
    React.useContext(Context.ServiceScreen);
  const [step, setStep] = React.useState<number>(1);
  const [formData, setFormData] = React.useState<IUpdateStudent>({
    avatar: selectedService?.student?.avatar,
  });

  useEffect((): void => {
    setFormData({
      ...selectedService?.student,
      province: selectedService?.province,
      city: selectedService?.city,
    });
  }, [selectedService]);

  useEffect((): void => {
    console.log(selectedService);
    setStep(1);
  }, [showModal]);

  function onBack(event: IUpdateStudent): void {
    setFormData({ ...formData, ...event });
    setStep(step - 1);
  }

  function onNext(event: IUpdateStudent): void {
    setFormData((prevFormData) => ({
      ...prevFormData,
      ...event,
    }));
    setStep(step + 1);
  }

  function onSubmit(event: IUpdateStudent): void {
    updateFunctionStudent!({
      ...formData,
      ...event,
      // id: selectedUser?.student?._id,
    });
  }

  function RenderUpdateStudent() {
    switch (step) {
      case 1: return <Components.StudentInformation defaultValues={formData} onSubmit={onNext  } onBack={onBack} />;
      case 2: return <Components.StudentLocation    defaultValue ={formData} onSubmit={onNext  } onBack={onBack} />;
      case 3: return <Components.StudentTiming      defaultValue ={formData} onSubmit={onSubmit} onBack={onBack} />;
      default: return null;
    }
  }

  return (
    <section id="student-update-modal-container">
      <CustomModal
        onClose={(): void => {
          setShowModal!("NONE");
          setFormData({});
          setStep(1);
        }}
        open={showModal === "UPDATE_STUDENT"}
      >
        <RenderUpdateStudent />
      </CustomModal>
    </section>
  );
};

export default UpdateStudent;
